// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HTMLEmbed_wrapper__TJBu7","fullwidth":"HTMLEmbed_fullwidth__lCGzi","grayscale":"HTMLEmbed_grayscale__IMyWB"};